import { SHOW_TOAST, HIDE_TOAST } from './Toast.constant';
import { IToastState, ToastActionsTypes } from './Toast.type';

const initialState: IToastState = {
  id: 0,
  active: false,
  message: '',
  variant: 'success',
};

export default function toastReducer(
  state = initialState,
  action: ToastActionsTypes,
): IToastState {
  switch (action.type) {
    case SHOW_TOAST:
      return {
        id: state.id + 1,
        active: true,
        message: action.payload.message,
        variant: action.payload.variant,
      };
    case HIDE_TOAST:
      return { ...state, active: false };
    default:
      return state;
  }
}
